import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as roomTypes from '../../room-types'

export const RESOURCE = {
  payload: {
    description:
      'A classification of rooms based on their usage (e.g., wet lab, lecture hall, conference room).',
    dimension: roomTypes.RESOURCE.payload,
    level: 0,
    name: 'Room Type',
    partialId: PartialId.Standard.create('room_type'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
